import api from "app/api";
import { AxiosResponse } from "axios";
import { SaveFormProps, globalMessageHandler } from "common";

type CapacityValidationResult = AxiosResponse<{ valid: boolean }>;

export function validateScheduleCapacity(item: any, id?: number | string) {
  return api.post<{ valid: boolean }>(
    id ? `schedules/${id}/validate-capacity` : "schedules/validate-capacity",
    item,
  );
}

export function validateEventCapacity(item: any, id?: number | string) {
  return api.post<{ valid: boolean }>(
    id ? `events/${id}/validate-capacity` : "events/validate-capacity",
    item,
  );
}

export function validateBatchEventCapacity(item: any) {
  return api.post<{ valid: boolean }>("events/validate-batch-capacity", item);
}

export async function saveWithCapacityWarning<T>(
  validateCapacity: () => Promise<CapacityValidationResult>,
  save: () => Promise<SaveFormProps<T>>,
): Promise<SaveFormProps<T>> {
  const validation = await validateCapacity();
  if (validation.success) {
    return save();
  }

  const messages = Array.isArray(validation.error?.limits)
    ? validation.error.limits.filter(
        (message: unknown): message is string => typeof message === "string",
      )
    : [];
  if (!messages.length) {
    return { success: false, error: validation.error };
  }

  return new Promise(resolve => {
    globalMessageHandler.confirm(
      {
        message: messages.join("\n"),
        severity: "warning",
      },
      async () => {
        const result = await save();
        resolve(result);
        if (!result.success) {
          throw result.error;
        }
        return true;
      },
      () => resolve({ success: false }),
    );
  });
}
